var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var SurveyEntryMyGiHistory = require('./surveyEntryMyGiHistory.jsx');

var DashboardWithoutDataMyGiHistory = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        return (
            <div className="dashboard-without-data">
                <div className="content-header-wrapper">
                    <div className="content-header-small content-header row column">
                        <h1>Doctor Visit Prep</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="large-6 column">
                        <div className="half-bg"></div>
                    </div>
                    <div className="large-6 column end">
                        <div className="hero-text-block">
                            <h2>Take the Gi History Report <br className="show-for-small-only" />and <br className="hide-for-small-only" />prep for your next <br className="show-for-small-only" />doctor Visit</h2>
                            <p>Here you will take 5-10 minutes to answer more detailed questions about your GI history. Your answers will be translated into a report written in “doctor speak”, so your doctor can quickly focus on your unique story. You will be able to print, save or email this report.</p>
                            <p>
                                <SurveyEntryMyGiHistory
                                    className="success"
                                    labelText="Take Gi History Report"
                                    clickTracking={this.props.clickTracking} />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
});

module.exports = DashboardWithoutDataMyGiHistory;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/dashboardWithoutDataMyGiHistory.jsx